import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ListItemRendererComponent } from 'gung-list';
import { EdiDispatchAdvicesActionConfigService } from '../../../services/edi-dispatch-advices-action-config/edi-dispatch-advices-action-config.service';
import { EdiService } from '../../../services/edi/edi.service';

@Component({
    selector: 'lib-edi-dispatch-card-list',
    templateUrl: './edi-dispatch-card-list.component.html',
    styleUrls: ['./edi-dispatch-card-list.component.css'],
    standalone: false
})
export class EdiDispatchCardListComponent extends ListItemRendererComponent<any[]> implements OnInit, AfterViewInit {
  constructor(public actionConfigService: EdiDispatchAdvicesActionConfigService) {
    super();
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }

  trackByFn(index: any, item: any) {
    return item.id;
  }
}
